/**
 * Registro de entityName -> entityEndpoint, poblado por entity-definition.service al cargar las
 * definiciones. Permite que resolveEndpoint() use el endpoint canonico (definido en morphed-be)
 * en vez de slugificar el entityName, lo que falla para nombres con acentos/palabras vacias
 * (ej. "Clam Información Privada del Evento" -> endpoint real "clam-informacion-privada-evento").
 */
const _endpoints = new Map<string, string>();

export function registerEntityEndpoints(nameToEndpoint: Array<[string, string]> | Map<string, string>): void {
	if (nameToEndpoint instanceof Map) {
		for (const [k, v] of nameToEndpoint) _endpoints.set(k, v);
	} else {
		for (const [k, v] of nameToEndpoint) _endpoints.set(k, v);
	}
}

export function lookupEntityEndpoint(entityName: string): string | undefined {
	return _endpoints.get(entityName);
}
